import React, { FC, useState } from 'react'
import { LoadingSpinner } from 'styles/loader'
import HeroConnector, { ConnectorProps as HeroProps } from '../connectors/Hero'
import { uploadHeroImage } from 'apis/private/heroImage'
import { updateImagePathBasedOnHostName } from '../helpers'
import styles from './artistProfile.module.scss'
import EditIcon from 'svg/edit-v3.svg'
import UploadIcon from 'svg/upload-v2.svg'
import useQA from 'hooks/useQA'
import { capitalizeString } from 'lib/helpers'
import Breadcrumb from 'components/SA/Breadcrumb'
import { useSelector } from 'react-redux'
import { getPageParamSection } from '../selectors'
const uploadHeroImageApi = async ({ imageFile, callbackFunc, addMessage }: Record<string, any>) => {
  const heroImageApi = await uploadHeroImage(imageFile)

  if (heroImageApi.success) {
    const { largeImage, smallImage } = heroImageApi.payload
    callbackFunc({
      largeHeroImage: largeImage,
      smallHeroImage: smallImage,
    })
  } else {
    const { errorMessage } = heroImageApi.payload
    let flashErrorMessage = 'Cover photo could not be uploaded'

    if (errorMessage) {
      flashErrorMessage = errorMessage
    }

    addMessage(flashErrorMessage, 'error')
    callbackFunc({
      isLoading: false,
    })
  }
}

const Hero: FC<HeroProps> = (props) => {
  const { heroImages, addMessage, sessionUserID, accountUserID, fullName } = props
  const { largeImage, smallImage } = heroImages
  const [state, handleState] = useState({
    isLoading: false,
    largeHeroImage: largeImage,
    smallHeroImage: smallImage,
  })
  const { isLoading, largeHeroImage, smallHeroImage } = state
  const myOwnAccount = sessionUserID === accountUserID
  const isHeroImgPresent = largeHeroImage || smallHeroImage
  const { testId } = useQA()
  const pageSection = useSelector(getPageParamSection)
  const onFileChanged = async (e: React.SyntheticEvent<HTMLInputElement>) => {
    e.preventDefault()

    if ((e.target as HTMLInputElement).files && (e.target as HTMLInputElement).files?.length) {
      const { files } = e.target as HTMLInputElement
      const imageFile = files?.[0]
      handleState((prevState) => ({ ...prevState, isLoading: true }))
      uploadHeroImageApi({
        imageFile,
        callbackFunc: (data: Record<string, any>) => {
          handleState((prevState) => ({ ...prevState, isLoading: false, ...data }))
        },
        addMessage,
      })
    }
  }

  const breadcrumbOptions =
    pageSection === 'artworks'
      ? [
          {
            name: 'Home',
            title: 'Home',
            url: '/',
          },
          {
            name: capitalizeString(fullName),
            title: `View profile of ${capitalizeString(fullName)} breadcrumb`,
            url: `/account/profile/${accountUserID}`,
          },
          {
            name: 'All Works',
            title: `${capitalizeString(fullName)} all Works`,
          },
        ]
      : [
          {
            name: 'Home',
            title: 'Home',
            url: '/',
          },
          {
            name: capitalizeString(fullName),
            title: capitalizeString(fullName),
          },
        ]

  return (
    <div className={styles.coverPhotoWrapper}>
      <div className={styles.breadcrumb} {...testId('breadcrumb-artist-profile')}>
        <Breadcrumb items={breadcrumbOptions} />
      </div>
      <div className={styles.coverPhoto}>
        <div className={styles.heroImageSection} {...testId('hero-image-section')}>
          {isLoading && (
            <>
              <div className={styles.overlay} />
              <p className={styles.loaderText}> Please wait while your image is uploaded... </p>
              <LoadingSpinner className={styles.loader} />
            </>
          )}
          {!isHeroImgPresent && myOwnAccount ? (
            <button
              className={styles.uploadSection}
              type='button'
              tabIndex={0}
              onClick={(ev) => ((ev.target as HTMLButtonElement).value = '')}
              onKeyDown={(ev) => ((ev.target as HTMLButtonElement).value = '')}
            >
              <UploadIcon />
              <p className={styles.uploadLabel}> add cover photo </p>
              <input
                className={styles.uploadInput}
                type='file'
                accept='image/*'
                onChange={onFileChanged}
                aria-label='hidden'
              />
            </button>
          ) : (
            ''
          )}
          {isHeroImgPresent && (
            <div className={styles.heroImage}>
              <picture className={styles.image}>
                <source
                  type='image/jpg'
                  media='(max-width:768px)'
                  srcSet={updateImagePathBasedOnHostName(smallHeroImage)}
                />
                <img
                  width='1440'
                  height='260'
                  src={updateImagePathBasedOnHostName(largeHeroImage)}
                  itemProp='image'
                />
              </picture>
            </div>
          )}
        </div>
        {isHeroImgPresent && myOwnAccount ? (
          <button
            className={styles.editHeroSection}
            {...testId('edit-hero-section')}
            type='button'
            tabIndex={0}
            onClick={(ev) => ((ev.target as HTMLButtonElement).value = '')}
            onKeyDown={(ev) => ((ev.target as HTMLButtonElement).value = '')}
          >
            <input
              className={styles.uploadInput}
              type='file'
              accept='image/*'
              onChange={onFileChanged}
              aria-label='hidden'
            />
            <div className={styles.editHeroIcon}>
              <EditIcon />
              <p>Edit Photo</p>
            </div>
          </button>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default HeroConnector(Hero)
